<template>
    <div id="devCenterIndex" class="devCenterIndex">
        <div class="center-container">
            <el-collapse v-model="activeTab" class="centerCollapse" v-if="centerData.length > 0">
                <el-collapse-item v-for="(item1, index) in centerData" :title="item1.name" :key="index" :name="index">
                    <div class="subCollapse" v-if="item1.children.length > 0">
                        <div class="subCollapseTag" v-for="(item2, index2) in item1.children" :key="index2">
                            <img class="subCollapseImg" :src="getImgUrl(item2.iconURL)" />
                            <p>{{ item2.title }}</p>
                            <p v-if="item2.subtitle" class="subTitle">{{ item2.subtitle }}</p>
                            <p class="subDetail">{{ item2.detail }}</p>
                            <div class="BtnGroup">
                                <div
                                    :style="{ visibility: item2.devGuide !== '' ? 'visible' : 'hidden' }"
                                    class="subCollapseBtn"
                                    @click="devGuideClick(item2.devGuide)"
                                >
                                    开发指南
                                </div>
                                <div
                                    :style="{ visibility: item2.APIdoc !== '' ? 'visible' : 'hidden' }"
                                    class="subCollapseBtn"
                                    @click="APIdocClick(item2.APIdoc, item2.title)"
                                >
                                    API文档
                                </div>
                                <div
                                    :style="{ visibility: item2.sampleCode !== '' ? 'visible' : 'hidden' }"
                                    class="subCollapseBtn"
                                    @click="sampleCodeClick(item2.sampleCode)"
                                >
                                    示例展示
                                </div>
                            </div>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <!-- 固定标签 -->
        <cfixed />
    </div>
</template>

<script>
import cfixed from 'src/components/cfixed';
import { devCenterUrl } from 'src/api/data';
import { get } from 'src/utils/httpUtil';

export default {
    name: 'devCenterIndex',
    components: {
        cfixed,
    },
    data() {
        return {
            searchInput: '',
            centerData: [],
            activeTab: [0, 1],
        };
    },
    methods: {
        getImgUrl(url) {
            return `${process.env.STATIC}${url}`;
        },
        devGuideClick(url) {
            if (url && url !== '') {
                window.open(`${window.location.origin}${url}`, '_blank');
            }
        },
        APIdocClick(url, title) {
            if (url && url !== '') {
                window.open(`${window.location.origin}${url}`, '_blank');
                // if (title.indexOf('OAuth') > -1) {
                //   window.open(url,"_blank")
                // } else {
                //   window.open(`${window.location.origin}${url}`,"_blank")
                // }
            }
        },
        sampleCodeClick(url) {
            if (url && url !== '') {
                location.href = '/playground/lod/';
            }
        },
    },
    mounted() {
        get(devCenterUrl).then((res) => {
            if (res) {
                this.centerData = res.data;
            }
        });
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.devCenterIndex
  width 100%
  background-color $background-grey

  .searchBGImg
    width 100%
    height 170px
    background-repeat: no-repeat
    background-size: 100% 100%
    object-fit: cover
    dom_center()

    .searchInput
      width 42%

  .center-container
    dom_center()
    width 100%
    background-color $background-grey

    >>> .el-collapse-item__wrap
      background transparent

    >>> .el-collapse-item__header
      font-size 14px
      border-top 1px solid rgba(112, 112, 112, 1)
      background-color transparent

    .centerCollapse
      width 73%
      margin-top 43px
      margin-bottom 129px

      .subCollapse
        width 100%
        display flex
        bottom 128px
        flex-wrap wrap
        justify-content flex-start

        .subCollapseTag
          display flex
          flex-direction column
          color $font-black
          width 300px
          height 330px
          margin 0% 0% 2% 2.5%
          padding: 17px;
          background $background-white
          align-items center

          &:hover
            box-shadow 0px 22px 35px 0px $background-shadowBlue,
            20px 0 21px -20px $background-shadowBlue,
            -15px 0 15px -15px $background-shadowBlue
            transition all 1s ease

          p:nth-of-type(1)
            padding-top 1%
            font-size 25px

          .subTitle
            font-size 25px

          .subDetail
            padding-top 5%
            height 47%
            overflow hidden
            font-size $font-size-text

          .subCollapseImg
            max-width 54px
            height auto
            margin-top 7.3%

          .BtnGroup
            width 100%
            dom_center()
            justify-content space-around

            .subCollapseBtn
              cursor pointer
              color #1F2436
              font-size 16px
              font-weight bold

              &:hover
                border-bottom 1px solid #1F2436
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/devDocs/devDocsIndex.vue